module.exports = __webpack_public_path__ + "img/dahag_yes.4918570f.png";